import { render, staticRenderFns } from "./EventsBiddingCreate.vue?vue&type=template&id=49afdc1c"
import script from "./EventsBiddingCreate.vue?vue&type=script&lang=js"
export * from "./EventsBiddingCreate.vue?vue&type=script&lang=js"
import style0 from "./EventsBiddingCreate.vue?vue&type=style&index=0&id=49afdc1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports